export const screenBreakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  xxl: "1440px",
  xxxl: "1537px",
};
